import { z } from "zod";
import zodToCamelCase from "zod-to-camel-case";

import { safeString } from "@/schema/public/components/base/safe-string.schema";

export const keywordsSchema = z.object({
  keyword: safeString,
  description: safeString,
});

export type Keywords = z.infer<typeof keywordsSchema>;

export const keywordsSchemaCamel = zodToCamelCase(keywordsSchema);
export type KeywordsCamel = z.infer<typeof keywordsSchemaCamel>;
